import { Image, Text, View } from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";
import { tableDataTableStyles } from "./DataTable";

export function DataTableHeaderGroup({ item }) {
  const { t } = useTranslation("translation");
  return (
    <>
      <View style={tableDataTableStyles.headerRow}>
        {/* Title */}
        <Text style={tableDataTableStyles.title}>{t("aeussre.tableLayer")}</Text>
        <Text style={tableDataTableStyles.title}>{t("aeussre.tableFrom")}</Text>
        <Text style={tableDataTableStyles.title}>{t("aeussre.tableTo")}</Text>
        <View style={tableDataTableStyles.title}>
          <Image
            src={{
              uri: "https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}q_{s,k}",
              method: "GET",
              headers: {},
            }}
            style={{
              height: 7,
              width: 12,
            }}
          />
        </View>
        <View style={tableDataTableStyles.title}>
          <Image
            src={{
              uri: " https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}R_{d,i}",
              method: "GET",
              headers: {},
            }}
            style={{
              height: 9,
              width: 14,
            }}
          />
          {/* <p>Rdi</p> */}
        </View>
        <View style={tableDataTableStyles.title}>
          {/* <p>Li&beta;</p> */}
          <Image
            src={{
              uri: "https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}L_{i,&space;\\beta}",
              method: "GET",
              headers: {},
            }}
            style={{
              height: 9,
              width: 13,
            }}
          />
        </View>
        <View style={tableDataTableStyles.title}>
          <Image
            src={{
              uri: "https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}R_{s,d,i}",
              method: "GET",
              headers: {},
            }}
            style={{
              height: 9,
              width: 19,
            }}
          />
        </View>
      </View>

      <View style={tableDataTableStyles.headerRowBottom}>
        <Text style={tableDataTableStyles.title}>{t("aeussre.tableLayerUnit")}</Text>
        <Text style={tableDataTableStyles.title}>[m]</Text>
        <Text style={tableDataTableStyles.title}>[m]</Text>
        <Text style={tableDataTableStyles.title}>[kN/m²]</Text>
        <Text style={tableDataTableStyles.title}>[kN/m]</Text>
        <Text style={tableDataTableStyles.title}>[m]</Text>
        <Text style={tableDataTableStyles.title}>[kN]</Text>
      </View>
    </>
  );
}
